export default __webpack_public_path__ + "static/media/main_m.54ecde31.jpg";